// Kekse, Kekse, Kekse
import Cookies from 'js-cookie'

//
// ███████╗████████╗ █████╗ ████████╗███████╗
// ██╔════╝╚══██╔══╝██╔══██╗╚══██╔══╝██╔════╝
// ███████╗   ██║   ███████║   ██║   █████╗
// ╚════██║   ██║   ██╔══██║   ██║   ██╔══╝
// ███████║   ██║   ██║  ██║   ██║   ███████╗
// ╚══════╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚══════╝
//
const state = {

  /* profile */
  account: {},
  user: {},
  accountId: 0,
  userId: 0,
  userFirstname: '',
  userLastname: '',
  userEmail: '',
  userAvatar: '',
  userTimezone: '0',
  userType: 0,

  /* admin */
  users: {},
  userTotal: 0,
  userDetail: {
    data: {
      firstname: '',
      lastname: '',
      a_company: ''
    },
    messages: {
      extensions: [],
      backups: []
    },
    id: 0,
    details: false,
    dirty: false,
    inProgress: false
  },
  userDetailId: 0,
  userDetailLoading: false,
  userSelected: [],
  allSelected: false,
  showDetailPage: false,
  remainingfreedays: 0,
  isAuthenticated: false,
  token: '',
  originalToken: null

}

//
//  ██████╗ ███████╗████████╗████████╗███████╗██████╗ ███████╗
// ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝
// ██║  ███╗█████╗     ██║      ██║   █████╗  ██████╔╝███████╗
// ██║   ██║██╔══╝     ██║      ██║   ██╔══╝  ██╔══██╗╚════██║
// ╚██████╔╝███████╗   ██║      ██║   ███████╗██║  ██║███████║
//  ╚═════╝ ╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝
//
const getters = {
  isImpersonated () {
    return Cookies.get('bm-original-token') !== undefined
  },

  isAuthenticated (state) {
    return state.isAuthenticated
  },

  isAdmin (state) {
    return state.userType === 99
  },

  isBetaTester (state) {
    return state.account.beta_tester
  },

  getAccount (state) {
    return state.account
  },

  getUser (state) {
    return state.user
  }
}

//
// ███╗   ███╗██╗   ██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ████╗ ████║██║   ██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ██╔████╔██║██║   ██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██║╚██╔╝██║██║   ██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║ ╚═╝ ██║╚██████╔╝   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝     ╚═╝ ╚═════╝    ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const mutations = {

  /**
   * Set account object
   *
   * @param state
   * @param payload
   */
  setAccount (state, payload) {
    state.account = payload
  },

  setAuthenticated (state, payload) {
    state.isAuthenticated = payload
    if (payload === false) {
      Cookies.remove('bm-token')
    }
  },

  setToken (state, payload) {
    state.token = payload
    Cookies.set('bm-token', payload, { sameSite: 'Lax' })
  },

  setOriginalToken (state, payload) {
    state.originalToken = payload
    Cookies.set('bm-original-token', payload, { sameSite: 'Lax' })
  },

  logout (state) {
    state.isAuthenticated = false
    Cookies.remove('bm-token')
    Cookies.remove('bm-original-token')
  },

  resetOriginalToken (state) {
    Cookies.set('bm-token', Cookies.get('bm-original-token'), { sameSite: 'Lax' })
    Cookies.remove('bm-original-token')
    state.token = state.originalToken
    state.originalToken = null
  },

  /* Profile */

  /**
     * Set users avatar
     *
     * @param state
     * @param payload
     */
  setUserAvatar (state, payload) {
    state.userAvatar = payload
  },

  /**
     * set user email
     *
     * @param state
     * @param payload
     */
  setUserEmail (state, payload) {
    state.userEmail = payload
  },

  /**
     * set users firstname
     *
     * @param state
     * @param payload
     */
  setUserFirstname (state, payload) {
    state.userFirstname = payload
  },

  /**
     * set users lastname
     *
     * @param state
     * @param payload
     */
  setUserLastname (state, payload) {
    state.userLastname = payload
  },

  /**
     * set users timezone
     *
     * @param state
     * @param payload
     */
  setUserTimezone (state, payload) {
    state.userTimezone = payload
  },

  /**
   * set users type
   *
   * @param state
   * @param payload
   */
  setUserType (state, payload) {
    state.userType = payload
  },

  /**
     * set users account Id
     *
     * @param state
     * @param payload
     */
  setUseraccountId (state, payload) {
    state.accountId = payload
  },

  /**
     * set users accounts trail
     *
     * @param state
     * @param payload
     */
  setUserRemainingfreedays (state, payload) {
    state.remainingfreedays = payload
  },

  /**
     * set user id
     *
     * @param state
     * @param payload
     */
  setUserId (state, payload) {
    state.userId = payload
  },

  /* ---- Profile ---- */

  /* Admin */

  /**
     * Add a user to the selected sites array
     *
     * @param state
     * @param payload
     */
  addSelectedUser (state, payload) {
    state.userSelected.push(payload)
    if (state.userSelected.length === state.users.data.length) {
      state.allSelected = true
    }
  },

  /**
     * Close the detail page
     *
     * @param state
     */
  closeDetailPage (state) {
    state.showDetailPage = false
  },

  /**
     * Remove a user from the selected users array
     *
     * @param state
     * @param payload
     */
  removeSelectedUsers (state, payload) {
    state.userSelected.splice(state.userSelected.indexOf(payload), 1)
    state.allSelected = false
  },

  /**
     * reset the selected users array
     *
     * @param state
     */
  unsetSelectAll (state) {
    state.userSelected = []
    state.allSelected = false
  },

  /**
     * Set user detail property, get in out of the users array
     *
     * @param state
     * @param payload
     */
  setUserDetail (state, payload) {
    // Get the id
    const id = parseInt(payload.data.id)

    // Get the index where we have to save data within the sites array
    const idx = state.users.data.findIndex((elm) => {
      return elm.id === id
    })
    state.users.data[idx].data = payload.data
    state.users.data[idx].details = true

    state.userDetail = state.users.data[idx]
  },

  /**
     * Set the user id
     *
     * @param state
     * @param payload
     */
  setUserDetailId (state, payload) {
    state.userDetailId = payload
  },

  /**
     * Set the loading state of site details pages
     *
     * @param state
     * @param payload
     */
  setUserDetailsLoading (state, payload) {
    state.userDetailsLoading = payload
  },

  /**
     * Set the allSelected property (all sites in the sites view are selected)
     *
     * @param state
     * @param payload
     */
  setSelectAll (state, payload) {
    state.userSelected = []
    state.users.data.forEach((item) => {
      state.userSelected.push(item.id)
    })

    state.allSelected = true
  },

  /**
   * Set user object
   *
   * @param state
   * @param payload
   */
  setUser (state, payload) {
    state.user = payload
  },

  /**
     * Set users object, get data from the backend and convert it for better usage
     *
     * @param state
     * @param payload
     */
  setUsers (state, payload) {
    // state.sites = payload;
    const data = payload.data
    const meta = payload.meta

    state.users.meta = meta
    state.users.data = []

    data.forEach((element) => {
      let user = this.transformDataItem(element)

      state.users.data.push(user)
    })
  },

  /**
     * Show the detail page for the user with the id of userDetailId
     *
     * @param state
     */
  showUserDetailPage (state) {
    state.showDetailPage = true
  },

  /**
     * Unselect all selected users
     *
     * @param state
     * @param payload
     */
  unSelectAll (state, payload) {
    state.userSelected = []
    state.allSelected = false
  }

}

//
//  █████╗  ██████╗████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ██╔══██╗██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ███████║██║        ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██╔══██║██║        ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║  ██║╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝  ╚═╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const actions = {

  /**
   * get account
   *
   * @param commit
   *
   * @returns {Promise<any>}
   */
  getAccount ({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/account')
        .then(response => {
          commit('setAccount', response.data.data)
          resolve(response.data)
        }
        )
        .catch(response => {
          resolve(response.data)
        }
        )
    })
  },

  /**
     * get user
     *
     * @param commit
     *
     * @returns {Promise<any>}
     */
  getUser ({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/user')
        .then(response => {
          commit('setUserAvatar', response.data.data.avatar)
          commit('setUserEmail', response.data.data.email)
          commit('setUserFirstname', response.data.data.firstname)
          commit('setUserLastname', response.data.data.lastname)
          commit('setUserTimezone', response.data.data.timezone)
          commit('setUseraccountId', response.data.data.account_id)
          commit('setUserType', response.data.data.role)
          commit('setUserRemainingfreedays', response.data.data.remainingfreedays)
          commit('setUserId', response.data.data.id)
          commit('setAuthenticated', true)
          commit('setToken', Cookies.get('bm-token'))

          commit('setUser', response.data.data)

          resolve(response.data)
        }
        )
        .catch(response => {
          resolve(response.data)
        }
        )
    })
  },

  getUserById ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/user/' + payload)
        .then(response => {
          resolve(response.data)
        }
        )
    })
  },

  getUsers ({ commit, state }, payload) {
    let limit = payload.limit
    let sort = payload.sort
    let dir = payload.dir
    let page = payload.page
    let search = payload.search

    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/users?page=' + page + '&limit=' + limit + '&sort=' + sort + '&dir=' + dir + '&search=' + search)
        .then(response => {
          commit('setUsers', response.data)
          resolve(response.data)
        }
        )
    })
  },

  impersonate ({ commit, state }, userId) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/impersonate/' + userId)
        .then(response => {
          commit('setOriginalToken', state.token)
          commit('setToken', response.data.token)
          resolve(response.data.token)
        }
        )
    })
  },

  login ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/login', payload)
        .then(response => {
          this._vm.$snotify.success('Login successfully')
          commit('setAuthenticated', true)
          commit('setToken', response.data)
          resolve(response.data)
        }
        ).catch((error) => {
          commit('setAuthenticated', false)
          this._vm.$snotify.error('Error')
          reject(error.data)
        }
        )
    })
  },

  register ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/register', payload)
        .then(response => {
          this._vm.$snotify.success('Done!')
          resolve(response.data)
        }).catch((error) => {
          this._vm.$snotify.error('Error')
          reject(error.data)
        })
    })
  },

  verify ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/verify', payload)
        .then(response => {
          this._vm.$snotify.success('Account verified successfully!')
          resolve(response.data)
        }).catch((error) => {
          this._vm.$snotify.error('Error verifying your account')
          reject(error.data)
        })
    })
  },

  forget ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/forget', payload)
        .then(response => {
          this._vm.$snotify.success('Done!')
          resolve(response.data)
        }).catch((error) => {
          this._vm.$snotify.error('Error')
          reject(error.data)
        })
    })
  },

  resetPassword ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/password/reset', payload)
        .then(response => {
          this._vm.$snotify.success('Reset successful!')
          resolve(response.data)
        }).catch((error) => {
          this._vm.$snotify.error('Error')
          reject(error.data)
        })
    })
  },

  /**
     * Remove a user
     *
     * @param dispatch
     * @param state
     * @param payload
     */
  removeUser ({ dispatch, state }, payload) {
    this._vm.axios.delete('/api/user/' + payload)
  },

  /**
     * Set the content for the user detail page and show the page
     *
     * @param commit
     * @param state
     * @param payload
     */
  setUserDetailContent ({ commit, state }, payload) {
    let userDetailId = parseInt(payload)

    if (userDetailId !== state.userDetailId) {
      commit('setUserDetailId', userDetailId)
      commit('setUserDetailsLoading', true)

      this._vm.axios.get('/api/user/' + userDetailId)
        .then(
          response => {
            // Update the site detail information
            commit('setUserDetail', response.data)
            commit('setUserDetailsLoading', false)
            commit('showUserDetailPage')
          })
        .catch(
          () => {
            this._vm.$snotify.error('Error getting user data')
          })
    }
  }
}

//
// ███████╗██╗  ██╗██████╗  ██████╗ ██████╗ ████████╗
// ██╔════╝╚██╗██╔╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝
// █████╗   ╚███╔╝ ██████╔╝██║   ██║██████╔╝   ██║
// ██╔══╝   ██╔██╗ ██╔═══╝ ██║   ██║██╔══██╗   ██║
// ███████╗██╔╝ ██╗██║     ╚██████╔╝██║  ██║   ██║
// ╚══════╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝
//
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
